import { render, staticRenderFns } from "./InternationalStudents.vue?vue&type=template&id=1a4dd8fc&scoped=true&"
import script from "./InternationalStudents.vue?vue&type=script&lang=js&"
export * from "./InternationalStudents.vue?vue&type=script&lang=js&"
import style0 from "./InternationalStudents.vue?vue&type=style&index=0&id=1a4dd8fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4dd8fc",
  null
  
)

export default component.exports